// extracted by mini-css-extract-plugin
export default {"modal":"OrganizationOnboardingModal-module__modal--zu_YY","animatedBackground":"OrganizationOnboardingModal-module__animatedBackground--oCoIC"};